import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sort-by',
  template: `<div class="head-sort" (click)="sort()">
    <ng-content></ng-content>&nbsp;
    <span *ngIf="sortBy === sortValue">
      <i [ngClass]="sortDir === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
    </span>
    <i *ngIf="sortBy !== sortValue" class="fa fa-sort"></i>
  </div>`,
})
export class SortByComponent {
  @Input() sortDir: string;
  @Input() sortBy: string;
  @Input() sortValue: string;

  @Output() private sorted = new EventEmitter();

  sort() {
    if (this.sortBy === this.sortValue) {
      this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortBy = this.sortValue;
      this.sortDir = 'asc';
    }

    let sortDir = this.sortDir;
    let sortBy = this.sortBy;

    this.sorted.emit({ sortDir, sortBy });
  }
}
